import { colors } from '@globals/themes/defaultTheme'
import ArrowForwardIosOutlined from '@mui/icons-material/ArrowForwardIosOutlined'
import ListItemIcon from '@mui/material/ListItemIcon'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { SxProps } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import useMobileRecognitionDrawer, {
  MobileRecognitionDrawerView,
} from '../useMobileRecognitionDrawer'

const paperStyle: SxProps = {
  '> svg': {
    color: `${colors.blueMedium} !important`,
  },
}

export const menuItemStyle: SxProps = {
  px: 2,
  py: 1.5,
  width: '100%',
}

type SendRecognitionNavMenuItemProps = {
  icon: React.ReactNode
  label: React.ReactNode
  view: MobileRecognitionDrawerView
  children: React.ReactNode
}

const SendRecognitionNavMenuItem: React.FC<SendRecognitionNavMenuItemProps> = ({
  icon,
  label,
  view,
  children,
}) => {
  const { openDrawer } = useMobileRecognitionDrawer()

  const handleClick = () => {
    openDrawer({ view })
  }

  return (
    <Paper sx={paperStyle} onClick={handleClick} id={`${view}-nav-menu-item`}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={menuItemStyle}>
        <Stack direction="row" alignItems="center">
          <ListItemIcon sx={{ '& svg': { color: `${colors.blueMedium} !important` } }}>
            {icon}
          </ListItemIcon>
          <Typography variant="body2">{label}</Typography>
        </Stack>
        <Stack direction="row" alignItems="center" gap={1}>
          {children}
          <ArrowForwardIosOutlined
            fontSize="small"
            sx={{ color: `${colors.grayLight} !important` }}
          />
        </Stack>
      </Stack>
    </Paper>
  )
}

export default SendRecognitionNavMenuItem
